import { ChangeDetectionStrategy, Component, computed, input, model } from '@angular/core';
import { AbstractComponent, FieldWrapperComponent } from '@spike/scaffolds';
import { FormsModule } from '@angular/forms';
import { Button } from 'primeng/button';
import { CommonModule } from '@angular/common';
import { InputText } from 'primeng/inputtext';
import { WorkflowState } from 'src/app/features/workflow/models/workflow-status.enum';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'spike-positions-filters-form',
  providers: [],
  imports: [CommonModule, Button, FormsModule, FieldWrapperComponent, InputText ],
  templateUrl: './positions-filters-form.html',
})
export class PositionsFiltersFormComponent extends AbstractComponent {
  // Inputs
  readonly workflowState = input.required<WorkflowState>();
  readonly searchFilter = model.required<any>();

  // Static
  private debounceTimeout?: any;
  // State

  public readonly subStateFilterId = computed(() => {
    const searchFilter = this.searchFilter();
    const workflowState = this.workflowState();
    if (workflowState && searchFilter)
      return searchFilter[workflowState.stateKey!];
  });

  public searchBySubState(substate?: number) {
    this.searchFilter.update(f => ({ ...f, [this.workflowState().stateKey!]: substate }));
  }


  updateFilter(key: string, value: any) {
    // 1. Puliamo il timeout precedente
    if (this.debounceTimeout) clearTimeout(this.debounceTimeout);

    // 2. Impostiamo un nuovo timeout
    this.debounceTimeout = setTimeout(() => {
      this.searchFilter.update(f => ({ ...f, [key]: value ? value : undefined }));
    }, 500); // 400ms di debounce

  }
}
